import { render, staticRenderFns } from "./RelatorioDetalhadoDespesaGeralFiltros.vue?vue&type=template&id=6bd1a4f0"
import script from "./RelatorioDetalhadoDespesaGeralFiltros.vue?vue&type=script&lang=js"
export * from "./RelatorioDetalhadoDespesaGeralFiltros.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports